import type { ProcessingStageView } from './ProcessingCard.types';

/**
 * Stage expanded by default: the running one, else the last one reached. So a finished stage keeps
 * its final tick on screen until the next stage starts, and the last stage stays open once complete.
 */
export const activeStageKey = (stages: ProcessingStageView[]): string | null =>
	(
		stages.find((stage) => stage.state === 'running') ??
		stages.filter((stage) => stage.state !== 'pending').at(-1)
	)?.key ?? null;
